export const environment = {
  name: 'prod',
  production: true,
  sentry: {
    dsn: 'https://290b12fe7c064164bafc20b61a48b5b7@sentry.io/222817',
  },
  crypt: {
    key: 'YRHnxXEA0Q2CpcpM1YGC92dR8iiK8onS',
    iv: 'a05ovnDRMwlwOft2',
  },
  web: {
    clientId: 'ionic',
    clientSecret: 'yNSsIAWrwr',
    identity: 'https://identity.rota.at',
    apiUrl: 'https://api.rota.at/1.0/',
    settings: 'https://tpm.rota.at/settings',
    redirect: 'https://tpm.rota.at',
    site: 'www.rota.at',
  },
};
